module.exports = __webpack_public_path__ + "static/media/Sample_Formatting_After.6e035c32.png";